import axios from "axios";
// import { MessageBox, Message } from "element-ui";
import moment from 'moment-timezone'
import md5 from "js-md5";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "app-id": "564452e4-6501-11e9-bd7e-b8cacc9eb5b0"
  }
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    const time = moment.tz(moment(), 'Asia/Hong_Kong').format('YYYY-MM-DD HH:mm:ss')
    const secret = md5(
      "6b12d09c-6501-11e9-bd7e-b8cacc9eb5b0" + ":__:E-AUDIT:__:" + time
    );
    config.headers["request-time"] = time;
    config.headers["secret"] = secret;
    // if (getToken()) {
    config.headers["Authorization"] = "";
    // }

    return config;
  },
  error => {
    // do something with request error
    console.log({ error });
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code.
   */
  response => {
    const res = response;
    return res.data;

    // if the custom code is not 20000, it is judged as an error.
    // if (res.status !== 200) {
    //   Message({
    //     message: res.data.error.message || 'error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (
    //     res.status === 50008 ||
    //     res.status === 50012 ||
    //     res.status === 50014
    //   ) {
    //     // to re-login
    //     MessageBox.confirm(
    //       'You have been logged out, you can cancel to stay on this page, or log in again',
    //       'Confirm logout',
    //       {
    //         confirmButtonText: 'Re-Login',
    //         cancelButtonText: 'Cancel',
    //         type: 'warning'
    //       }
    //     ).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(res.statusText || 'error')
    // } else {
    //   // 当请求成功但验证签名不一致时，提示错误，返回登录页面
    //   if (!verifySign(res.data)) {
    //     console.log('sign verification failure, api url: ' + res.config.url)
    //     Message({
    //       message: 'Sign Verification Failure',
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    //     store.dispatch('user/logout')
    //     router.push(`/login?redirect=${router.app.$route.fullPath}`)
    //   }
    //   return res.data
    // }
  },
  error => {
    console.log({ error });
    // if (axios.isCancel(error)) {
    //   // 为了终结promise链 就是实际请求 不会走到.catch(rej=>{});这样就不会触发错误提示之类了。
    //   return new Promise(() => {})
    // } else {
    //   if (error.message.includes('timeout')) {
    //     Message({
    //       message: 'Network connection error, please try again',
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    //   } else if (!error.response || error.response.status === 500) {
    //     Message({
    //       message: 'Network connection failure',
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    //   }  else {
    //     Message({
    //       message: error.response.data.error.message,
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    //   }
      return Promise.reject(error)
    // }
  }
);

export default service;
